module.exports = __webpack_public_path__ + "static/media/cover.8b58f02c.png";